import { CSSProperties } from 'react';

export const arrowStyles: CSSProperties = {
  position: 'absolute',
  zIndex: 2,
  top: 'calc(50% - 15px)',
  cursor: 'pointer',
  right: '15px',
  color: '#fff',
  opacity: 0.5,
};

export const indicatorStyles: CSSProperties = {
  background: 'rgba(255, 255, 255, 0.1)',
  width: 8,
  height: 8,
  display: 'inline-block',
  borderRadius: '50px',
  margin: '0 8px',
};
